

const Loader = () => (
    <div>
        <div class="loader"></div>
    </div>
);

export default Loader;